// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a6942d88","513":"0365193d","703":"5d4af40c"}[chunkId] + ".chunk.js";
};